var _rule = require("../rule.js");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _rule2.default.makeRule({
    name: "math-align-extra-break",
    severity: _rule2.default.Severity.WARNING,
    selector: "blockMath",
    pattern: /(\\{2,})\s*\\end{align}/,
    message: "Extra space at end of block:\nDon't end an align block with backslashes"
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/gorgon/rules/math-align-extra-break.js
 ** module id = 223
 ** module chunks = 0 2
 **/